import { Injectable } from '@angular/core';
import { IframeMode } from '../../../enums/iframe-mode.enum';

@Injectable({
  providedIn: 'root'
})
export class UrlParamsService {
  private instanceId: string;
  
  constructor() {
    this.cleanupOrphanedKeys();
    this.instanceId = this.generateInstanceId();
    this.captureInitialParameters();
  }

  private generateInstanceId(): string {
    const urlParams = new URLSearchParams(window.location.search);
    const iframeModeParam = urlParams.get('iframeMode');
    
    let prefix = 'none';
    if (iframeModeParam === IframeMode.INLINE || iframeModeParam === 'INLINE') {
      prefix = 'inline';
    } else if (iframeModeParam === IframeMode.WIDGET || iframeModeParam === 'WIDGET') {
      prefix = 'widget';
    }
    
    const randomPart = Math.random().toString(36).slice(2, 11);
    return `${prefix}_${Date.now()}_${randomPart}`;
  }

  private cleanupOrphanedKeys(): void {
    const urlParams = new URLSearchParams(window.location.search);
    const iframeModeParam = urlParams.get('iframeMode');
    
    let prefix = 'none';
    if (iframeModeParam === IframeMode.INLINE || iframeModeParam === 'INLINE') {
      prefix = 'inline';
    } else if (iframeModeParam === IframeMode.WIDGET || iframeModeParam === 'WIDGET') {
      prefix = 'widget';
    }
    
    const keys = Object.keys(sessionStorage);
    keys.forEach(key => {
      if (key.startsWith(`${prefix}_`) && key.includes('_')) {
        sessionStorage.removeItem(key);
      }
    });
  }

  private getKey(key: string): string {
    return `${this.instanceId}_${key}`;
  }

  private captureInitialParameters() {
    const currentUrl = window.location.href;
    const currentSearch = window.location.search;
    
    if (currentSearch && currentUrl.includes('booking-agent')) {
      const urlParams = new URLSearchParams(currentSearch);
      
      const params = {
        phone_number: urlParams.get('phone_number'),
        service: urlParams.get('service')
      };
      
      if (params.phone_number || params.service) {
        sessionStorage.setItem(this.getKey('bookingAgentParams'), JSON.stringify(params));
      }
    }
  }

  getStoredParams(): any {
    const stored = sessionStorage.getItem(this.getKey('bookingAgentParams'));
    return stored ? JSON.parse(stored) : null;
  }

  clearStoredParams() {
    sessionStorage.removeItem(this.getKey('bookingAgentParams'));
  }
}